import React from "react";

export const SectionHeader = props => (
  <header className="report-SectionHeader">
    <h5>{props.headerText}</h5>
  </header>
);
